module.exports = __webpack_public_path__ + "static/media/Spanish ProFACT Training Manual-translatededited-byARSP-FINAL (clean version).9c1aa42a.pdf";